import { createStyles } from '@/styles/theme/utils';

export const signupStyles = createStyles({
   signup_area_con: {
      bg: 'background',
   },
   container: {
      px: '12',
      '@media (max-width: 767px)': {
         px: '0',
      },
   },
   signup_area: {
      display: 'flex',
      justifyContent: 'center',
   },
   signup_box: {
      w: '650px',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: '20px',
      bg: 'black',
      h: '100vh',
      '@media (max-width: 767px)': {
         w: '100%',
      },
   },
   signup_form: {
      w: '420px',
      '@media (max-width: 767px)': {
         w: '100%',
      },
   },
   double_input: {
      display: 'flex',
      alignItems: 'start',
      gap: '10px',
      justifyContent: 'space-between',
      w: '100%',
      maxW: '100%',
      '@media (max-width: 767px)': {
         flexDirection: 'column',
         gap: '20px',
      },
   },
   signup_btn_con: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      w: '100%',
      pt: '2',
   },
   date_input: {
      pl: '10',
      '&::-webkit-calendar-picker-indicator': {
         display: 'none',
         appearance: 'none',
      },
   },
   num_input: {
      '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
         appearance: 'none',
         margin: 0,
      },
      '&[type=number]': {
         MozAppearance: 'textfield', // Hide for Firefox
      },
   },
   icon_box: {
      position: 'absolute',
      left: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      color: 'gray.400',
      zIndex: 9,
   },
   send_code: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
   },
   privacy_info: {
      border: '1px solid darkGray',
      py: '8',
      '@media (max-width: 767px)': {
         py: '6',
      },
   },
   privacy_info_con: {
      px: '10',
      overflow: 'auto',
      w: 'full',
      maxH: '400px',
      '@media (max-width: 767px)': {
         px: '6',
      },
   },
   payment_details: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4',
      w: '100%',
      mb: '2',
   },
   payment_details_con: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '6',
   },
   payment_details_total: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '6',
      borderTop: 'solid 1px #222A31',
      borderBottom: 'solid 1px #222A31',
      py: '2.5',
   },
   card_details: {
      display: 'flex',
      alignItems: 'center',
      h: '10',
      w: '100%',
      rounded: '12px',
      bg: '#202020',
      overflow: 'hidden',
      pl: '4',
      position: 'relative',
   },
   card_icon: {
      position: 'absolute',
      top: '13px',
      left: '14px',
   },
   auto_renewal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '4',
      width: '100%',
      mb: '2',
   },
   multiselect_box_con: {
      position: 'relative',
      w: 'full',
   },
   multiselect_box: {
      w: 'full',
      rounded: '12px',
      bg: '#202020',
      p: '2',
      pr: '8',
      minH: '40px',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '5px',
      position: 'relative',
   },
   multiselect_box_dropdown_con: {
      w: '420px',
      '@media (max-width: 767px)': {
         w: 'calc(100% - 48px)',
      },
   },
   support_info: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '20px',
      p: '4',
      rounded: '12px',
      background: '#b5b5b57d',
      w: 'full',
   },
   upload_btn_box: {
      w: 'calc(100% - 100px)',
   },
   resident_input: {
      width: '100%',
      '& div': {
         width: '100%',
         '& button': {
            borderRadius: '12px',
            background: ' #202020',
            '& span': {
               color: 'white',
            },
         },
         '& ul': {
            background: '#111',
            '& div': {
               background: '#111',
            },
            '& li': {
               '&:hover': {
                  background: '#222',
               },
            },
         },
      },
   },

   resident_input_error: {
      '& div': {
         '& button': {
            borderRadius: '12px',
            background: ' #202020',
            border: '1px solid #f87171',
            '& span': {
               color: 'white',
            },
         },
         '& ul': {
            background: '#111',
            '& div': {
               background: '#111',
            },
            '& li': {
               '&:hover': {
                  background: '#222',
               },
            },
         },
      },
   },

   checkbox: {
      '& label': {
         cursor: 'pointer',
      },
      marginTop: '2',
      display: 'flex',
      justifyContent: 'center',
   },
   kyc_area: {
      display: 'flex',
      justifyContent: 'center',
      overflow: 'auto',
   },
   kyc_con: {
      width: '1020px',
      '@media (max-width: 1100px)': {
         width: '700px',
      },
      '@media (max-width: 767px)': {
         width: '100%',
      },
   },

   iframeImageArea: {
      '& iframe': {
         '& body img': {
            maxWidth: '100% !important',
            height: 'auto !important',
         },
      },
   },
});
